import Box from '../../../../Common/Box';
import {Tab, Tabs} from '@mui/material';
import {createSimpleTheme,} from '../../getShadowTheme';
import ColorView from '../ColorView';
import React, {useContext, useEffect, useState} from 'react';
import {ThemeContext} from "../../../../Common/Contexts";
import {alpha, Theme, useTheme} from "@mui/material/styles";
import Save from "@mui/icons-material/Save";
import DarkModeSwitch from "../DarkModeSwitch";
import ThemeSelect from "../ThemeSelect";
import uiStore from '../../../stores/uiStore';
import ControlButton from '../../../../Common/ControlButton';
import ThemeDialog from "./ThemeDialog";
import {createField} from "./utils";
import {Field} from "./interfaces";

export function MobileThemeSettings() {

    const theme: Theme = useTheme();
    const {shadowTheme, setTheme} = useContext(ThemeContext);
    const [saveDialogOpen, setSaveDialogOpen] = useState(false);
    const [fields, setFields] = useState<Field[]>([]);
    const [tabIndex, setTabIndex] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    useEffect(() => {
        const primary = createField("primary", theme, "palette.primary.main", (theme, main) => {
            setTheme(createSimpleTheme(shadowTheme.name, theme.palette.mode, main, theme.palette.background.default, theme.palette.background.paper));
        })
        const background = createField("background", theme, "palette.background.default", (theme, backgroundDefault) => {
            setTheme(createSimpleTheme(shadowTheme.name, theme.palette.mode, theme.palette.primary.main, backgroundDefault, theme.palette.background.paper));
        });
        const paper = createField("paper", theme, "palette.background.paper", (theme, paper) => {
            setTheme(createSimpleTheme(shadowTheme.name, theme.palette.mode, theme.palette.primary.main, theme.palette.background.default, paper));
        });

        const fields = [
            primary,
            background,
            paper,
        ]
        setFields(fields);
    }, [shadowTheme.name]);

    return <Box
            column
            expand
            sx={{
                height: "200px",
                pointerEvents: 'all',
            }}
    >
        <Box row center padding={`5px`} bgcolor={fields[tabIndex]?.currentColor}/>

        <Tabs
                sx={{minHeight: '25px', height: '25px'}}
                value={tabIndex}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
        >
            {
                fields.map(field => {
                    return <Tab
                            sx={{
                                minHeight: '16px',
                                height: '16px',
                                textTransform: "initial",
                                fontWeight: "initial,"
                            }}
                            key={field.name}
                            label={field.name}
                    >
                    </Tab>
                })
            }
        </Tabs>
        <Box row
             padding={"5px 0px"}
             sx={{
                 alignItems: "center"
             }}
        >
            {uiStore.isMobile && <ThemeSelect/>}

            <DarkModeSwitch
                    variant={"mini"}
                    checked={theme.palette.mode === "dark"}
                    sx={{marginLeft: "0px"}}
                    onChange={bool => {
                        const mode = bool ? "dark" : "light"
                        setTheme(createSimpleTheme(
                                shadowTheme.name,
                                mode,
                                theme.palette.primary.main,
                                theme.palette.background.default,
                                theme.palette.background.paper
                        ));
                    }}/>

            <ControlButton
                    width={36}
                    sx={{
                        border: "2px solid " + alpha(theme.palette.primary.main, 0.2),
                        margin: "0px 8px",
                        marginRight: "14px",
                        // background: "#454545"
                    }}
                    onClick={() => {
                        setSaveDialogOpen(true);
                    }}
                    icon={Save}/>
        </Box>
        {fields.length > 0 &&
                <Box column width={"100%"}>
                    <ColorView
                            defaultColor={fields[tabIndex].currentColor}
                            onColorUpdate={color => {
                                fields[tabIndex].currentColor = color;
                                fields[tabIndex].setColor(theme, color)
                            }}/>
                </Box>}
        <ThemeDialog open={saveDialogOpen} onClose={() => setSaveDialogOpen(false)} theme={theme}/>

    </Box>
}
